import { Result } from "antd";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import s from "./NotFoundPage.module.scss";

export function NotFoundPage(): ReactElement {
  const { t } = useTranslation();
  return <Result
    className={s.container}
    status="404"
    title={t("notfoundpage.title")}
    subTitle={t("notfoundpage.subTitle")}
  />
}
